var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Voice',{attrs:{"detail":{
  no: '03',
  belong: 'THE BLOSSOM KYOTO',
  title: 'マネージャ―',
  profile: 'THE BLOSSOM KYOTO',
  name: '呉 君',
  date: '２０１８年入社',
  sm: {
    belong: 'THE BLOSSOM KYOTO',
    name: 'マネージャ―',
  },
  intro: '３度の開業で得たゆるぎない経験。地域の魅力を見つけ、旅行者目線でサービス向上を目指す。',
  content: [
    {
      title: '地域を大切にする会社の理念に共鳴',
      text: '私は中国で、「まちづくり」について大学で専門的に学びました。日本の文化にも興味を持っていたので、より深くまちづくりを研究するために日本の大学院へ進学しました。就職活動ではその分野に携われる会社を探す中で、ＪＲ九州ホテルズアンドリゾーツの「地域に根ざしたホテルづくり」という理念に共感したのが、この会社との出会いです。旅行が趣味でツアーコンダクターの仕事も経験していた私にとって、ホテルは憧れの職場でもありました。入社できて本当にうれしかったです。まずは、ＪＲ九州ホテルブラッサム博多中央に配属され、ホテル業務の基礎をしっかりと身に付けながらキャリアをスタートすることができました。',
    },
    {
      title: '始めての開業は慣れないことの連続',
      text: '2019年はTHE BLOSSOM HAKATA Premier、2021年にはTHE BLOSSOM KUMAMOTOの開業に携わりました。熊本ではマネージャーとして、サービス面でこだわった部分も多く、初めての経験に最初は慣れないスタッフも多かったと思います。それでも少しずつ経験を積んでいくうちに、皆で成長していくのを実感できました。スタートを同じくした仲間と一緒に成長していくのは、本当にやりがいを感じます。',
    },
    {
      title: '海外旅行者にも最高のサービスを',
      text: '2022年には京都で開業準備から関わり、任せられた仕事も多くなりました。各地のホテルから集まったスタッフとともに、積極的に意見交換を行いながら進めていきました。完全なるシッティングチェックインなどフルサービスを目指していたので、初めての試みにもチーム一丸となって臨みました。それでもまだ課題はたくさんあります。インバウンド需要も今後さらに増えていきますので、海外のお客さまにも当ホテルを選んでよかったとご満足いただけるよう、しっかりとしたサービスを目指してまいります。',
    },
    {
      title: 'まずはその土地を好きになることが大切',
      text: '弊社は全国15ヶ所にホテルがあり、時には転勤もあります。転勤は大変だと思う人もいますが、私は新しい場所での楽しみ方を見つけることで、その土地に慣れ親しんできました。休日にはカメラを持ってあちこち旅に出かけ、そこでの気づきをホテルのスタッフへフィードバックしています。旅行者目線に立ったサービスは、お客さまに好意的に受け取っていただきやすいので、できるだけその考えを現場のスタッフにも感じてもらいたいと思っています。そして、また機会があれば、今後も新規開業に携わりたいと考えています。',
    } ],
  career: [
    {
      year: '2018',
      text: 'ＪＲ九州ホテルブラッサム博多中央にホテルスタッフとして配属',
    },
    {
      year: '2019',
      text: 'THE BLOSSOM HAKATA Premierへ開業準備のため異動',
    },
    {
      year: '2021',
      text: 'THE BLOSSOM KUMAMOTOへ開業準備のため異動、マネージャーへ昇格',
    },
    {
      year: '2022',
      text: 'THE BLOSSOM KYOTOへ開業準備のため異動',
      isLast: true,
    } ],
  message: 'ＪＲ九州ホテルズアンドリゾーツは、常に新しいことに挑戦できる場所。<br>サービスだけではなく、自分の個性や得意分野を活かせる職場です。<br>中には、私のような外国籍のスタッフも在籍しています。<br>外国語を話せるスタッフも多くいますし、海外スタッフ向けの研修も用意されています。私たちと一緒に、やりたいことを実現していきましょう！',
  caption: true,
  navi: {
    prev: {
      title: '１年目から高みを目指してチャレンジの連続。副支配人となった今も日々成長を感じている',
      path: '02',
    },
    next: {
      title: '日本の丁寧なおもてなしを体験し接客業へ。海外のお客さまから「ありがとう」と言われるたび仕事の価値を実感',
      path: '04',
    },
  },
}}})}
var staticRenderFns = []

export { render, staticRenderFns }